/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CommesseResponseDTO,
  SituazioneCommesseResponseDTO,
} from '../models/index';
import {
    CommesseResponseDTOFromJSON,
    CommesseResponseDTOToJSON,
    SituazioneCommesseResponseDTOFromJSON,
    SituazioneCommesseResponseDTOToJSON,
} from '../models/index';

export interface GetCommesseRequest {
    data?: Date;
    idPersonale?: number;
    idCliente?: number;
}

export interface GetCommesseByRangeRequest {
    dataInizio?: Date;
    dataFine?: Date;
    idPersonale?: number;
}

export interface GetSituazioneCommesseRequest {
    dataDa?: Date;
    dataA?: Date;
    idCommessa?: number;
    idPersonale?: number;
}

/**
 * 
 */
export class CommesseApi extends runtime.BaseAPI {

    /**
     */
    async getCommesseRaw(requestParameters: GetCommesseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CommesseResponseDTO>>> {
        const queryParameters: any = {};

        if (requestParameters['data'] != null) {
            queryParameters['data'] = (requestParameters['data'] as any).toISOString();
        }

        if (requestParameters['idPersonale'] != null) {
            queryParameters['idPersonale'] = requestParameters['idPersonale'];
        }

        if (requestParameters['idCliente'] != null) {
            queryParameters['idCliente'] = requestParameters['idCliente'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Commesse`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CommesseResponseDTOFromJSON));
    }

    /**
     */
    async getCommesse(requestParameters: GetCommesseRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CommesseResponseDTO>> {
        const response = await this.getCommesseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCommesseByRangeRaw(requestParameters: GetCommesseByRangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CommesseResponseDTO>>> {
        const queryParameters: any = {};

        if (requestParameters['dataInizio'] != null) {
            queryParameters['dataInizio'] = (requestParameters['dataInizio'] as any).toISOString();
        }

        if (requestParameters['dataFine'] != null) {
            queryParameters['dataFine'] = (requestParameters['dataFine'] as any).toISOString();
        }

        if (requestParameters['idPersonale'] != null) {
            queryParameters['idPersonale'] = requestParameters['idPersonale'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Commesse/byRange`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CommesseResponseDTOFromJSON));
    }

    /**
     */
    async getCommesseByRange(requestParameters: GetCommesseByRangeRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CommesseResponseDTO>> {
        const response = await this.getCommesseByRangeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSituazioneCommesseRaw(requestParameters: GetSituazioneCommesseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SituazioneCommesseResponseDTO>>> {
        const queryParameters: any = {};

        if (requestParameters['dataDa'] != null) {
            queryParameters['dataDa'] = (requestParameters['dataDa'] as any).toISOString();
        }

        if (requestParameters['dataA'] != null) {
            queryParameters['dataA'] = (requestParameters['dataA'] as any).toISOString();
        }

        if (requestParameters['idCommessa'] != null) {
            queryParameters['idCommessa'] = requestParameters['idCommessa'];
        }

        if (requestParameters['idPersonale'] != null) {
            queryParameters['idPersonale'] = requestParameters['idPersonale'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Commesse/situazioneCommesse`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SituazioneCommesseResponseDTOFromJSON));
    }

    /**
     */
    async getSituazioneCommesse(requestParameters: GetSituazioneCommesseRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SituazioneCommesseResponseDTO>> {
        const response = await this.getSituazioneCommesseRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
